import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesProducts } from "./../../constants";

export const requestDeleteProductVariant = async (
  productVariantId: string
): Promise<void> => {
  return await instance.delete(
    buildUrl(ApiRoutesProducts.ProductVariant, productVariantId)
  );
};
